import type { OptionProps, Option } from '@usealloy/component-library';
import { Box } from '@usealloy/component-library';

import type { ActionOptionMeta } from '../types';
import { StyledDropdownComponentText } from './styles';


interface ContentProps<T> extends OptionProps<T, false> {
  showIcon?: boolean;
}

export default function Content<T extends Option<ActionOptionMeta>>(
  {
    data: {
      icon,
      label,
      meta: {
        textColor,
        underlineColor,
      } = {},
    },
    isDisabled,
    showIcon = false,
  }: ContentProps<T>,
) {
  return (
    <Box justifyContent="flex-start">
      {showIcon && !!icon && icon}
      <StyledDropdownComponentText
        disabled={isDisabled}
        textColor={textColor}
        underlineColor={underlineColor}
      >
        {label}
      </StyledDropdownComponentText>
    </Box>
  );
}
